export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0f2559] py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/b0dfad47411a5cab4bb37e29cd654d91/ad7ef5d5c8ae0c30ee62e19ca8db67c2.png"
                alt="Agent Ben"
                className="w-8 h-8 object-contain rounded-full"
              />
            </div>
            <span className="text-white font-bold text-sm">Agent Ben</span>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { id: "home", label: "Home" },
              { id: "about", label: "About" },
              { id: "links", label: "Links" },
              { id: "contact", label: "Contact" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-white/50 hover:text-white text-xs transition-colors duration-200 cursor-pointer whitespace-nowrap font-medium"
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Copyright */}
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Agent Ben. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
